import { Component, OnInit } from '@angular/core';
import { patientSectionModeEnum } from '@modules/patient/models/patient-section-visibility.enum';
import { PatientDisplayMode } from '@modules/patient/models/patient-display-mode.enum';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { PatientModel } from '@shared/models/rx-models/interfaces/patient-model';
import { Observable } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { PatientFacade } from '../../patient.facade';
import { PatientPopupCommands } from '@modules/patient/services/patient-app-iframe-communication.service';

@Component({
	selector: 'rx-patient',
	templateUrl: './patient.component.html',
	styleUrls: ['./patient.component.scss'],
	providers: [PatientFacade]
})
export class PatientComponent extends BaseDestroyableComponent implements OnInit {
	isReadOnly$: Observable<boolean> = this.facade.isReadOnly$;
	patient$: Observable<PatientModel | null> = this.facade.patient$;
	maxPatientLastNameLength$: Observable<number | undefined> = this.facade.maxPatientLastNameLength$;
	patientSectionMode$: Observable<patientSectionModeEnum> = this.facade.patientSectionMode$;
	isEditButtonVisibleForReadOnly$: Observable<boolean> = this.facade.isEditButtonVisibleForReadOnly$;
	isClearButtonVisibleForReadOnly$: Observable<boolean> = this.facade.isClearButtonVisibleForReadOnly$;
	isRxFromReferralDoctorAndUserIsScannigCenter$: Observable<boolean> = this.facade.isRxFromReferralDoctorAndUserIsScannigCenter$;
	isIntuitiveFlow$: Observable<boolean> = this.facade.isIntuitiveFlow$;
	patientSectionVersionEnum = patientSectionModeEnum;
	regulatoryDOBMask$: Observable<string | undefined> = this.facade.regulatoryDOBMask$;
	dateFormat$: Observable<string | undefined> = this.facade.dateFormat$;

	readonly PatientDisplayMode = PatientDisplayMode;
	readonly patientDisplayMode$: Observable<PatientDisplayMode> = this.facade.patientDisplayMode$;

	constructor(private readonly facade: PatientFacade) {
		super();
	}

	ngOnInit(): void {
		this.facade.initializePatientAppStreams$.pipe(takeUntil(this.componentAlive$)).subscribe();
		this.facade.patientPopupCommandHandler$.pipe(takeUntil(this.componentAlive$)).subscribe();
		this.facade.loadExistingUnifiedPatientHandler$.pipe(takeUntil(this.componentAlive$)).subscribe();
	}

	editPatient(): void {
		this.facade.patientPopupCommandEmitter$.next(PatientPopupCommands.EditPatient);
	}

	clearPatient(): void {
		this.facade.clearPatient().pipe(take(1), takeUntil(this.componentAlive$)).subscribe();
	}
}
